// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.save-reminder-overlay {
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background-color: rgba(0, 0, 0, 0.5);
    display: flex;
    justify-content: center;
    align-items: center;
    z-index: 1000;
  }
  
  .save-reminder-popup {
    background-color: white;
    border-radius: 8px;
    padding: 20px;
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
    max-width: 400px;
    width: 90%;
  }
  
  .save-reminder-content {
    display: flex;
    flex-direction: column;
    align-items: center;
    text-align: center;
  }
  
  .save-reminder-content h3 {
    margin-top: 0;
    color: #0d9488;
    font-size: 18px;
    font-weight: 600;
  }
  
  .save-reminder-content p {
    margin: 12px 0;
    color: #374151;
    font-size: 16px;
  }
  
  .save-reminder-button {
    margin-top: 16px;
    padding: 8px 24px;
    background-color: #0d9488;
    color: white;
    border: none;
    border-radius: 6px;
    font-size: 14px;
    font-weight: 500;
    cursor: pointer;
    transition: background-color 0.2s;
  }


  .save-reminder-button:hover {
    background-color: #0f766e;
  }
  
  @media (max-width: 600px) {
    .save-reminder-popup {
      width: 85%;
      padding: 16px;
    }
  
    .save-reminder-content h3 {
      font-size: 16px;
    }
  
    .save-reminder-content p {
      font-size: 14px;
    }
  }
  
  `, "",{"version":3,"sources":["webpack://./src/components/CustomPopup.css"],"names":[],"mappings":"AAAA;IACI,eAAe;IACf,MAAM;IACN,OAAO;IACP,QAAQ;IACR,SAAS;IACT,oCAAoC;IACpC,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,aAAa;EACf;;EAEA;IACE,uBAAuB;IACvB,kBAAkB;IAClB,aAAa;IACb,0CAA0C;IAC1C,gBAAgB;IAChB,UAAU;EACZ;;EAEA;IACE,aAAa;IACb,sBAAsB;IACtB,mBAAmB;IACnB,kBAAkB;EACpB;;EAEA;IACE,aAAa;IACb,cAAc;IACd,eAAe;IACf,gBAAgB;EAClB;;EAEA;IACE,cAAc;IACd,cAAc;IACd,eAAe;EACjB;;EAEA;IACE,gBAAgB;IAChB,iBAAiB;IACjB,yBAAyB;IACzB,YAAY;IACZ,YAAY;IACZ,kBAAkB;IAClB,eAAe;IACf,gBAAgB;IAChB,eAAe;IACf,iCAAiC;EACnC;;;EAGA;IACE,yBAAyB;EAC3B;;EAEA;IACE;MACE,UAAU;MACV,aAAa;IACf;;IAEA;MACE,eAAe;IACjB;;IAEA;MACE,eAAe;IACjB;EACF","sourcesContent":[".save-reminder-overlay {\r\n    position: fixed;\r\n    top: 0;\r\n    left: 0;\r\n    right: 0;\r\n    bottom: 0;\r\n    background-color: rgba(0, 0, 0, 0.5);\r\n    display: flex;\r\n    justify-content: center;\r\n    align-items: center;\r\n    z-index: 1000;\r\n  }\r\n  \r\n  .save-reminder-popup {\r\n    background-color: white;\r\n    border-radius: 8px;\r\n    padding: 20px;\r\n    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);\r\n    max-width: 400px;\r\n    width: 90%;\r\n  }\r\n  \r\n  .save-reminder-content {\r\n    display: flex;\r\n    flex-direction: column;\r\n    align-items: center;\r\n    text-align: center;\r\n  }\r\n  \r\n  .save-reminder-content h3 {\r\n    margin-top: 0;\r\n    color: #0d9488;\r\n    font-size: 18px;\r\n    font-weight: 600;\r\n  }\r\n  \r\n  .save-reminder-content p {\r\n    margin: 12px 0;\r\n    color: #374151;\r\n    font-size: 16px;\r\n  }\r\n  \r\n  .save-reminder-button {\r\n    margin-top: 16px;\r\n    padding: 8px 24px;\r\n    background-color: #0d9488;\r\n    color: white;\r\n    border: none;\r\n    border-radius: 6px;\r\n    font-size: 14px;\r\n    font-weight: 500;\r\n    cursor: pointer;\r\n    transition: background-color 0.2s;\r\n  }\r\n\r\n\r\n  .save-reminder-button:hover {\r\n    background-color: #0f766e;\r\n  }\r\n  \r\n  @media (max-width: 600px) {\r\n    .save-reminder-popup {\r\n      width: 85%;\r\n      padding: 16px;\r\n    }\r\n  \r\n    .save-reminder-content h3 {\r\n      font-size: 16px;\r\n    }\r\n  \r\n    .save-reminder-content p {\r\n      font-size: 14px;\r\n    }\r\n  }\r\n  \r\n  "],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
